import $ from "jquery";
import {active} from "./const.js";

$('.js-q').on('click', (event) => {
  $(event.currentTarget).toggleClass(active);
  $(event.currentTarget).next().slideToggle();
});
